function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { ALIGN_TYPES } from "constants/align-types";
import { PROJECTS_BLUE_COLOR_NAME } from "styles/color-consts";
import { sharedDefaultAdvancedProps } from "segments/desktop/shape/layouts/default-props";
const shapeColor = PROJECTS_BLUE_COLOR_NAME;
export default _object_spread({
    // Base
    innerRadius: "100",
    outerRadius: "35",
    x: "0",
    y: "0",
    scale: "1",
    cornerRadius: "0",
    rotation: "45",
    fill: shapeColor,
    align: ALIGN_TYPES.LEFT
}, sharedDefaultAdvancedProps);
